import React, { useMemo } from 'react'

import {
  MaterialResponse,
  Organization,
  shortTerms,
  Unit,
  UUID,
  StageResponse,
  AssigneesProjectResponseType,
} from '@builddocs/data-management'
import { FILE_STORE_API } from '@builddocs/filestore-api'
import { ViewerContext } from '@builddocs/shared/feature-pdf-viewer'
import {
  Checkbox,
  Box,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Radio,
  Paper,
  Tooltip,
  Stack,
  Typography,
} from '@mui/material'
import { visuallyHidden } from '@mui/utils'

const StarIcon = () => (
  <svg
    fill="none"
    height="12"
    viewBox="0 0 12 12"
    width="12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.21875 4.28906C7.28985 4.43916 7.43152 4.54423 7.5957 4.56934L10.3623 4.99121L8.33301 7.07715C8.22215 7.19112 8.17214 7.35097 8.19824 7.50781L8.67285 10.3652L6.24414 9.00684C6.11133 8.9326 5.95259 8.92366 5.81348 8.97949L5.75586 9.00684L3.32617 10.3643L3.80566 7.50781C3.8319 7.35068 3.78213 7.19023 3.6709 7.07617L1.6377 4.99121L4.4209 4.56934C4.58619 4.5442 4.72807 4.43761 4.79883 4.28613L6 1.71387L7.21875 4.28906Z"
      fill="#333333"
      stroke="#333333"
      strokeLinejoin="round"
    />
    <mask fill="white" id="path-2-inside-1_14512_77506">
      <path
        clipRule="evenodd"
        d="M5.99878 1C6.1316 0.999643 6.25309 1.07843 6.31214 1.20321L7.67104 4.07481L10.7015 4.53824C10.8327 4.55831 10.9417 4.65467 10.9828 4.78689C11.0239 4.91912 10.99 5.06434 10.8952 5.16165L8.69115 7.42551L9.21466 10.5712C9.23758 10.709 9.18364 10.8484 9.07567 10.9304C8.9677 11.0125 8.82459 11.0228 8.70694 10.957L5.99969 9.44366L3.29304 10.957C3.17532 11.0228 3.03211 11.0124 2.92412 10.9303C2.81613 10.8481 2.76227 10.7086 2.78537 10.5708L3.31269 7.42551L1.10499 5.16187C1.01009 5.06458 0.976058 4.91924 1.01718 4.7869C1.0583 4.65457 1.16745 4.55817 1.29879 4.5382L4.34579 4.07481L5.68641 1.20489C5.74485 1.0798 5.86595 1.00036 5.99878 1ZM6.0017 2.19308L4.89131 4.57013C4.84063 4.67864 4.74213 4.7539 4.62811 4.77124L2.09737 5.15611L3.93198 7.0372C4.01432 7.12162 4.05163 7.24322 4.03169 7.36216L3.59646 9.95815L5.83557 8.70623C5.93813 8.64889 6.06119 8.64888 6.16375 8.70621L8.40452 9.9588L7.97231 7.36171C7.95255 7.24301 7.98979 7.12173 8.07187 7.03742L9.90389 5.15571L7.3895 4.7712C7.27622 4.75387 7.17826 4.67936 7.12737 4.57182L6.0017 2.19308Z"
        fillRule="evenodd"
      />
    </mask>
    <path
      clipRule="evenodd"
      d="M5.99878 1C6.1316 0.999643 6.25309 1.07843 6.31214 1.20321L7.67104 4.07481L10.7015 4.53824C10.8327 4.55831 10.9417 4.65467 10.9828 4.78689C11.0239 4.91912 10.99 5.06434 10.8952 5.16165L8.69115 7.42551L9.21466 10.5712C9.23758 10.709 9.18364 10.8484 9.07567 10.9304C8.9677 11.0125 8.82459 11.0228 8.70694 10.957L5.99969 9.44366L3.29304 10.957C3.17532 11.0228 3.03211 11.0124 2.92412 10.9303C2.81613 10.8481 2.76227 10.7086 2.78537 10.5708L3.31269 7.42551L1.10499 5.16187C1.01009 5.06458 0.976058 4.91924 1.01718 4.7869C1.0583 4.65457 1.16745 4.55817 1.29879 4.5382L4.34579 4.07481L5.68641 1.20489C5.74485 1.0798 5.86595 1.00036 5.99878 1ZM6.0017 2.19308L4.89131 4.57013C4.84063 4.67864 4.74213 4.7539 4.62811 4.77124L2.09737 5.15611L3.93198 7.0372C4.01432 7.12162 4.05163 7.24322 4.03169 7.36216L3.59646 9.95815L5.83557 8.70623C5.93813 8.64889 6.06119 8.64888 6.16375 8.70621L8.40452 9.9588L7.97231 7.36171C7.95255 7.24301 7.98979 7.12173 8.07187 7.03742L9.90389 5.15571L7.3895 4.7712C7.27622 4.75387 7.17826 4.67936 7.12737 4.57182L6.0017 2.19308Z"
      fill="#333333"
      fillRule="evenodd"
    />
    <path
      d="M6.31214 1.20321L7.21604 0.775464V0.775463L6.31214 1.20321ZM5.99878 1L6.00147 2H6.00147L5.99878 1ZM7.67104 4.07481L6.76714 4.50255C6.90929 4.80293 7.19137 5.01308 7.51987 5.06331L7.67104 4.07481ZM10.7015 4.53824L10.5503 5.52675L10.7015 4.53824ZM10.8952 5.16165L10.1787 4.46406L10.1787 4.46407L10.8952 5.16165ZM8.69115 7.42551L7.97464 6.72793C7.75271 6.95588 7.65248 7.27584 7.70471 7.58967L8.69115 7.42551ZM9.21466 10.5712L8.22823 10.7354L9.21466 10.5712ZM9.07567 10.9304L8.47069 10.1342L9.07567 10.9304ZM8.70694 10.957L9.19488 10.0841L9.19488 10.0841L8.70694 10.957ZM5.99969 9.44366L6.48763 8.57078C6.18439 8.40127 5.8149 8.40129 5.51168 8.57082L5.99969 9.44366ZM3.29304 10.957L3.78106 11.8298H3.78106L3.29304 10.957ZM2.92412 10.9303L3.52957 10.1344H3.52957L2.92412 10.9303ZM2.78537 10.5708L1.79913 10.4054L1.79913 10.4054L2.78537 10.5708ZM3.31269 7.42551L4.29893 7.59085C4.35165 7.27636 4.25123 6.95558 4.02859 6.7273L3.31269 7.42551ZM1.10499 5.16187L0.389091 5.86008H0.389091L1.10499 5.16187ZM1.29879 4.5382L1.44914 5.52683H1.44914L1.29879 4.5382ZM4.34579 4.07481L4.49614 5.06345C4.82672 5.01317 5.11029 4.801 5.25181 4.49804L4.34579 4.07481ZM5.68641 1.20489L4.78039 0.781663L4.78039 0.781664L5.68641 1.20489ZM4.89131 4.57013L3.98529 4.1469L3.98529 4.1469L4.89131 4.57013ZM6.0017 2.19308L6.9056 1.76534C6.73986 1.41509 6.38669 1.19212 5.99921 1.19309C5.61172 1.19405 5.25967 1.41878 5.09568 1.76985L6.0017 2.19308ZM4.62811 4.77124L4.47776 3.7826L4.47776 3.7826L4.62811 4.77124ZM2.09737 5.15611L1.94702 4.16748C1.57639 4.22384 1.26841 4.48278 1.14924 4.83823C1.03007 5.19368 1.11972 5.58593 1.38148 5.85432L2.09737 5.15611ZM3.93198 7.0372L3.21609 7.73541L3.21609 7.73541L3.93198 7.0372ZM4.03169 7.36216L3.04545 7.19681L3.04545 7.19681L4.03169 7.36216ZM3.59646 9.95815L2.61022 9.7928C2.54663 10.1721 2.70622 10.5543 3.02069 10.7758C3.33516 10.9972 3.74876 11.0187 4.08447 10.831L3.59646 9.95815ZM5.83557 8.70623L6.32359 9.57907H6.32359L5.83557 8.70623ZM6.16375 8.70621L6.65169 7.83334L6.65169 7.83333L6.16375 8.70621ZM8.40452 9.9588L7.91658 10.8317C8.2521 11.0192 8.66543 10.9979 8.97983 10.7767C9.29423 10.5556 9.45405 10.1738 9.39095 9.79463L8.40452 9.9588ZM7.97231 7.36171L8.95874 7.19755L7.97231 7.36171ZM8.07187 7.03742L8.78837 7.735L8.07187 7.03742ZM9.90389 5.15571L10.6204 5.8533C10.8817 5.5849 10.9711 5.19297 10.852 4.83781C10.7329 4.48266 10.4253 4.22383 10.0551 4.16721L9.90389 5.15571ZM7.3895 4.7712L7.23833 5.7597H7.23833L7.3895 4.7712ZM7.12737 4.57182L6.22347 4.99956L6.22347 4.99956L7.12737 4.57182ZM6.31214 1.20321L7.21604 0.775463C6.99957 0.318018 6.53562 -0.00144887 5.99608 4.82798e-06L5.99878 1L6.00147 2C5.72759 2.00074 5.50662 1.83884 5.40824 1.63095L6.31214 1.20321ZM7.67104 4.07481L8.57494 3.64706L7.21604 0.775464L6.31214 1.20321L5.40824 1.63095L6.76714 4.50255L7.67104 4.07481ZM10.7015 4.53824L10.8527 3.54973L7.82221 3.0863L7.67104 4.07481L7.51987 5.06331L10.5503 5.52675L10.7015 4.53824ZM10.9828 4.78689L11.9378 4.49011C11.7893 4.01256 11.3824 3.63074 10.8527 3.54973L10.7015 4.53824L10.5503 5.52675C10.283 5.48588 10.0941 5.29677 10.0279 5.08367L10.9828 4.78689ZM10.8952 5.16165L11.6117 5.85924C11.9684 5.49287 12.085 4.96386 11.9378 4.49011L10.9828 4.78689L10.0279 5.08367C9.96282 4.87437 10.0115 4.63582 10.1787 4.46406L10.8952 5.16165ZM8.69115 7.42551L9.40765 8.1231L11.6117 5.85923L10.8952 5.16165L10.1787 4.46407L7.97464 6.72793L8.69115 7.42551ZM9.21466 10.5712L10.2011 10.4071L9.67758 7.26135L8.69115 7.42551L7.70471 7.58967L8.22823 10.7354L9.21466 10.5712ZM9.07567 10.9304L9.68065 11.7267C10.0951 11.4118 10.2827 10.8972 10.2011 10.4071L9.21466 10.5712L8.22823 10.7354C8.1925 10.5207 8.27222 10.285 8.47069 10.1342L9.07567 10.9304ZM8.70694 10.957L8.219 11.8299C8.68651 12.0912 9.25851 12.0474 9.68065 11.7267L9.07567 10.9304L8.47069 10.1342C8.67689 9.97751 8.96268 9.95432 9.19488 10.0841L8.70694 10.957ZM5.99969 9.44366L5.51175 10.3165L8.219 11.8299L8.70694 10.957L9.19488 10.0841L6.48763 8.57078L5.99969 9.44366ZM3.29304 10.957L3.78106 11.8298L6.48771 10.3165L5.99969 9.44366L5.51168 8.57082L2.80503 10.0842L3.29304 10.957ZM2.92412 10.9303L2.31867 11.7262C2.74087 12.0474 3.31327 12.0914 3.78106 11.8298L3.29304 10.957L2.80503 10.0842C3.03736 9.95425 3.32334 9.97753 3.52957 10.1344L2.92412 10.9303ZM2.78537 10.5708L1.79913 10.4054C1.71692 10.8958 1.90421 11.4109 2.31867 11.7262L2.92412 10.9303L3.52957 10.1344C3.72804 10.2854 3.80761 10.5214 3.77161 10.7361L2.78537 10.5708ZM3.31269 7.42551L2.32646 7.26016L1.79913 10.4054L2.78537 10.5708L3.77161 10.7361L4.29893 7.59085L3.31269 7.42551ZM1.10499 5.16187L0.389091 5.86008L2.5968 8.12371L3.31269 7.42551L4.02859 6.7273L1.82088 4.46367L1.10499 5.16187ZM1.01718 4.7869L0.0622219 4.49016C-0.0851068 4.96428 0.0317816 5.49372 0.389091 5.86008L1.10499 5.16187L1.82088 4.46367C1.9884 4.63543 2.03722 4.87419 1.97214 5.08365L1.01718 4.7869ZM1.29879 4.5382L1.14844 3.54957C0.618228 3.6302 0.210733 4.01223 0.0622219 4.49016L1.01718 4.7869L1.97214 5.08365C1.90587 5.29691 1.71668 5.48615 1.44914 5.52683L1.29879 4.5382ZM4.34579 4.07481L4.19544 3.08618L1.14844 3.54957L1.29879 4.5382L1.44914 5.52683L4.49614 5.06345L4.34579 4.07481ZM5.68641 1.20489L4.78039 0.781664L3.43976 3.65158L4.34579 4.07481L5.25181 4.49804L6.59243 1.62812L5.68641 1.20489ZM5.99878 1L5.99608 4.82798e-06C5.45662 0.00145829 4.99449 0.323327 4.78039 0.781663L5.68641 1.20489L6.59243 1.62813C6.49521 1.83627 6.27529 1.99926 6.00147 2L5.99878 1ZM4.89131 4.57013L5.79733 4.99336L6.90772 2.61631L6.0017 2.19308L5.09568 1.76985L3.98529 4.1469L4.89131 4.57013ZM4.62811 4.77124L4.77846 5.75987C5.238 5.68998 5.61165 5.39086 5.79733 4.99336L4.89131 4.57013L3.98529 4.1469C4.0696 3.96641 4.24625 3.81781 4.47776 3.7826L4.62811 4.77124ZM2.09737 5.15611L2.24772 6.14474L4.77846 5.75987L4.62811 4.77124L4.47776 3.7826L1.94702 4.16748L2.09737 5.15611ZM3.93198 7.0372L4.64788 6.33899L2.81327 4.4579L2.09737 5.15611L1.38148 5.85432L3.21609 7.73541L3.93198 7.0372ZM4.03169 7.36216L5.01792 7.52751C5.08918 7.10251 4.95876 6.65775 4.64788 6.33899L3.93198 7.0372L3.21609 7.73541C3.06988 7.58549 3.01408 7.38393 3.04545 7.19681L4.03169 7.36216ZM3.59646 9.95815L4.58269 10.1235L5.01792 7.52751L4.03169 7.36216L3.04545 7.19681L2.61022 9.7928L3.59646 9.95815ZM5.83557 8.70623L5.34756 7.8334L3.10844 9.08532L3.59646 9.95815L4.08447 10.831L6.32359 9.57907L5.83557 8.70623ZM6.16375 8.70621L6.65169 7.83333C6.24588 7.60649 5.75333 7.60652 5.34755 7.8334L5.83557 8.70623L6.32359 9.57907C6.12293 9.69126 5.8765 9.69127 5.67582 9.57909L6.16375 8.70621ZM8.40452 9.9588L8.89245 9.08592L6.65169 7.83334L6.16375 8.70621L5.67582 9.57909L7.91658 10.8317L8.40452 9.9588ZM7.97231 7.36171L6.98587 7.52587L7.41808 10.123L8.40452 9.9588L9.39095 9.79463L8.95874 7.19755L7.97231 7.36171ZM8.07187 7.03742L7.35537 6.33984C7.04548 6.65813 6.91529 7.10174 6.98587 7.52587L7.97231 7.36171L8.95874 7.19755C8.98982 7.38428 8.9341 7.58532 8.78837 7.735L8.07187 7.03742ZM9.90389 5.15571L9.18739 4.45813L7.35537 6.33984L8.07187 7.03742L8.78837 7.735L10.6204 5.8533L9.90389 5.15571ZM7.3895 4.7712L7.23833 5.7597L9.75272 6.14422L9.90389 5.15571L10.0551 4.16721L7.54067 3.78269L7.3895 4.7712ZM7.12737 4.57182L6.22347 4.99956C6.41 5.39375 6.78181 5.68989 7.23833 5.7597L7.3895 4.7712L7.54067 3.78269C7.77064 3.81786 7.94651 3.96497 8.03126 4.14407L7.12737 4.57182ZM6.0017 2.19308L5.0978 2.62083L6.22347 4.99956L7.12737 4.57182L8.03127 4.14407L6.9056 1.76534L6.0017 2.19308Z"
      fill="#333333"
      mask="url(#path-2-inside-1_14512_77506)"
    />
  </svg>
)

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

type Order = 'asc' | 'desc'

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key,
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string },
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number,
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number])

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])

    if (order !== 0) {
      return order
    }
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

type HeadCell = {
  materials: {
    name: string
    label: string
  }[]
  works: {
    name: string
    label: string
  }[]
  organizations: {
    name: string
    label: string
  }[]
  assignees: {
    name: string
    label: string
  }[]
}

const headCells: HeadCell = {
  materials: [
    {
      name: 'materialName',
      label: 'Наименование',
    },
    {
      name: 'manufacturer',
      label: 'Производитель',
    },
    {
      name: 'unit',
      label: 'Ед.измерения',
    },
    {
      name: 'amount',
      label: 'Количество',
    },
  ],
  works: [
    {
      name: 'title',
      label: 'Наименование работ',
    },
    {
      name: 'place',
      label: 'Место проведения',
    },
    {
      name: 'workDate',
      label: 'Дата работ',
    },
  ],
  organizations: [
    {
      name: 'name',
      label: 'Наименование',
    },
    {
      name: 'roleInContract',
      label: 'Роль',
    },
    {
      name: 'inn',
      label: 'ИНН',
    },
  ],
  assignees: [
    {
      name: 'lastName',
      label: 'Фамилия',
    },
    {
      name: 'firstName',
      label: 'Имя',
    },
    {
      name: 'middleName',
      label: 'Отчество',
    },
    {
      name: 'positionDescription',
      label: 'Должность',
    },
    {
      name: 'organizationName',
      label: 'Организация',
    },
  ],
}

const assigneeDocumentHeadCell = {
  name: 'documentName',
  label: 'Приказ',
}

const nameFieldId = {
  works: 'sectionId',
  materials: 'materialId',
  organizations: 'inn',
  assignees: 'employmentId',
}

interface EnhancedTableProps {
  numSelected: number
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void
  onLastNameSearch?: (event: React.ChangeEvent<HTMLInputElement>) => void
  order: Order
  orderBy: string
  rowCount: number
  tableType: 'materials' | 'works' | 'organizations' | 'assignees'
  isSingleSelect?: boolean
  disabledItems?: UUID[]
  maxSelectableItems?: number
  showAssigneeDocument?: boolean
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    tableType,
    isSingleSelect,
    onLastNameSearch,
    disabledItems,
    maxSelectableItems,
    showAssigneeDocument,
  } = props
  const selectableItemsCount =
    maxSelectableItems ?? rowCount - (disabledItems?.length ?? 0)
  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property)
    }

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          {!isSingleSelect && (
            <Checkbox
              checked={
                selectableItemsCount > 0 && numSelected >= selectableItemsCount
              }
              color="primary"
              indeterminate={
                numSelected > 0 && numSelected < selectableItemsCount
              }
              inputProps={{
                'aria-label': 'select all desserts',
              }}
              onChange={onSelectAllClick}
            />
          )}
        </TableCell>
        {(tableType === 'assignees' && showAssigneeDocument
          ? [...headCells[tableType], assigneeDocumentHeadCell]
          : headCells[tableType]
        ).map(headCell => (
          <TableCell
            key={headCell.name}
            align="left"
            sortDirection={orderBy === headCell.name ? order : false}
            sx={{ pl: 1 }}
          >
            <TableSortLabel
              active={orderBy === headCell.name}
              direction={orderBy === headCell.name ? order : 'asc'}
              onClick={createSortHandler(headCell.name)}
            >
              {headCell.label}
              {orderBy === headCell.name ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
            {headCell.name === 'lastName' && (
              <TextField
                name="lastNameSearch"
                size="small"
                onChange={onLastNameSearch}
              />
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

export default function TableForSelect({
  onSelect,
  items,
  selected,
  tableType,
  isSingleSelect,
  showDefaultAssignees,
  showAssigneeDocument,
  uniqueAssigneeByEmployment,
  assigneeIdField = 'employmentId',
}: {
  selected: UUID[] | string[]
  items:
    | Record<UUID, MaterialResponse>
    | Record<UUID, StageResponse>
    | Record<UUID, AssigneesProjectResponseType>
    | Record<string, Organization & { roleInContract: string }>
  onSelect: ((ids: string | string[]) => void) | ((ids: UUID | UUID[]) => void)
  tableType: 'materials' | 'works' | 'organizations' | 'assignees'
  isSingleSelect?: boolean
  showDefaultAssignees?: boolean
  showAssigneeDocument?: boolean
  uniqueAssigneeByEmployment?: boolean
  assigneeIdField?: 'employmentId' | 'journalAssigneeId'
}) {
  const viewerContext = React.useContext(ViewerContext)
  const [order, setOrder] = React.useState<Order>('asc')
  const [orderBy, setOrderBy] = React.useState<string>(
    headCells[tableType][0].name,
  )
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)

  const handleRequestSort = (
    _event: React.MouseEvent<unknown>,
    property: string,
  ) => {
    const isAsc = orderBy === property && order === 'asc'

    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const disabledItems = Object.values(items).flatMap(item => {
    const itemId = item?.[assigneeIdField]

    return itemId && item?.isDisabled ? [itemId] : []
  })

  const maxSelectableItems = uniqueAssigneeByEmployment
    ? new Set(
        Object.values(items)
          .filter(item => !item?.isDisabled)
          .map(item => item?.employmentId)
          .filter(Boolean),
      ).size
    : undefined

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (tableType === 'assignees' && uniqueAssigneeByEmployment) {
      if (selected.length !== maxSelectableItems) {
        const selectedIds = new Set(selected)
        const employmentIds = new Set<string>()
        const newSelecteds = Object.values(items)
          .sort(
            (left, right) =>
              Number(selectedIds.has(String(right?.[assigneeIdField]))) -
              Number(selectedIds.has(String(left?.[assigneeIdField]))),
          )
          .flatMap(item => {
            const itemId = item?.[assigneeIdField]
            const employmentId = item?.employmentId

            if (
              !itemId ||
              !employmentId ||
              item?.isDisabled ||
              employmentIds.has(employmentId)
            ) {
              return []
            }

            employmentIds.add(employmentId)
            return [String(itemId)]
          })

        onSelect(newSelecteds)
      } else {
        onSelect([])
      }
      return
    }

    if (tableType === 'assignees') {
      if (
        selected.length !==
        Object.keys(items).length - (disabledItems?.length ?? 0)
      ) {
        const newSelecteds = Object.keys(items).filter(
          item => !disabledItems.includes(item),
        )

        onSelect(newSelecteds)
      } else {
        onSelect([])
      }
      return
    }

    if (event.target.checked) {
      const newSelecteds = Object.keys(items)

      onSelect(newSelecteds)
      return
    } else {
      onSelect([])
    }
  }

  const handleClick = (
    _event: React.MouseEvent<unknown>,
    id: string,
    isDisabled: boolean,
    employmentId?: string | number,
  ) => {
    if (tableType === 'assignees' && isDisabled) {
      return
    }
    if (isSingleSelect) {
      onSelect(id)
    } else {
      const selectedIndex = selected.indexOf(id)
      let newSelected: string[] = []

      if (selectedIndex === -1) {
        const selectedIdsForEmployment = employmentId
          ? Object.values(items).flatMap(item => {
              const itemId = item?.[assigneeIdField]

              return itemId && item?.employmentId === employmentId
                ? [String(itemId)]
                : []
            })
          : []
        const selectedWithoutSameEmployment = uniqueAssigneeByEmployment
          ? selected.filter(
              selectedId =>
                !selectedIdsForEmployment.includes(String(selectedId)),
            )
          : selected

        newSelected = newSelected.concat(selectedWithoutSameEmployment, id)
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1))
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1))
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1),
        )
      }

      onSelect(newSelected)
    }
  }

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const isSelected = (name: string) => selected.indexOf(name) !== -1

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - Object.keys(items).length)
      : 0

  const [lastNameSearch, setLastNameSearch] = React.useState('')
  const handleLastNameSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLastNameSearch(e.target.value)
  }

  // начальный список
  const [initialItems] = React.useState(() => Object.values(items))

  const sortedList = useMemo(() => {
    return stableSort(initialItems, getComparator(order, orderBy))
  }, [initialItems, order, orderBy])

  const filteredResults = useMemo(() => {
    return sortedList.filter(item => {
      const lastName = String(item?.lastName)

      return lastName
        ?.toLowerCase()
        ?.includes(lastNameSearch?.trim()?.toLocaleLowerCase())
    })
  }, [lastNameSearch, sortedList])

  const tableContent = filteredResults
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    .map((row, index) => {
      const rawItemId =
        tableType === 'assignees'
          ? row[assigneeIdField]
          : row[nameFieldId[tableType]]

      if (!rawItemId) {
        return null
      }

      const itemId = String(rawItemId)
      const isItemSelected = isSelected(itemId)
      const isItemDisabled = Boolean(row?.isDisabled)
      const labelId = `enhanced-table-checkbox-${index}`

      return (
        <TableRow
          key={itemId}
          hover
          aria-checked={isItemSelected}
          role="checkbox"
          selected={isItemSelected}
          style={{
            opacity: tableType === 'assignees' && isItemDisabled ? 0.5 : 1,
            cursor:
              tableType === 'assignees' && isItemDisabled
                ? 'not-allowed'
                : 'pointer',
          }}
          tabIndex={-1}
          title={
            tableType === 'assignees'
              ? row?.isDisabled
                ? 'Подписант не доступен для выбора'
                : ''
              : ''
          }
          onClick={event =>
            handleClick(event, itemId, isItemDisabled, row?.employmentId)
          }
        >
          <TableCell padding="checkbox">
            {isSingleSelect ? (
              <Radio checked={isItemSelected} name="radio-buttons" />
            ) : (
              <Checkbox
                checked={isItemSelected}
                color="primary"
                disabled={tableType === 'assignees' && isItemDisabled}
                inputProps={{
                  'aria-labelledby': labelId,
                }}
              />
            )}
          </TableCell>
          {(tableType === 'assignees' && showAssigneeDocument
            ? [...headCells[tableType], assigneeDocumentHeadCell]
            : headCells[tableType]
          ).map((cell, ind) => {
            const cellContent =
              cell.name === 'unit'
                ? shortTerms(row.unit as Unit)
                : row[cell.name]
            const documentId =
              cell.name === 'documentName' ? row.documentId : undefined

            const showStar =
              tableType === 'assignees' &&
              cell.name === 'lastName' &&
              showDefaultAssignees &&
              // @ts-expect-error тяжело типизировать
              row.isDefault === true

            return (
              <TableCell
                key={cell.name + ind}
                align="left"
                component="th"
                id={labelId}
                scope="row"
                sx={{ pl: 1 }}
              >
                {documentId ? (
                  <Link
                    component="button"
                    underline="hover"
                    onClick={event => {
                      event.stopPropagation()
                      viewerContext.setPDF({
                        url: `${FILE_STORE_API}/permits/document/${documentId}`,
                        fileName: String(cellContent),
                      })
                    }}
                  >
                    {cellContent}
                  </Link>
                ) : showStar ? (
                  <Stack alignItems="center" direction="row" spacing="4px">
                    <Typography
                      sx={{
                        lineHeight: '12px',
                      }}
                      variant="body2"
                    >
                      {cellContent}
                    </Typography>
                    <Tooltip title="Подписант по умолчанию">
                      <Box
                        component="span"
                        sx={{
                          width: '12px',
                          height: '12px',
                        }}
                      >
                        <StarIcon />
                      </Box>
                    </Tooltip>
                  </Stack>
                ) : (
                  cellContent
                )}
              </TableCell>
            )
          })}
        </TableRow>
      )
    })

  return (
    <>
      <Table
        stickyHeader
        aria-label="sticky table"
        aria-labelledby="tableTitle"
        size="medium"
        sx={{ minWidth: 750 }}
      >
        <EnhancedTableHead
          disabledItems={disabledItems}
          isSingleSelect={isSingleSelect}
          maxSelectableItems={maxSelectableItems}
          numSelected={selected.length}
          order={order}
          orderBy={orderBy}
          rowCount={Object.keys(items).length}
          showAssigneeDocument={showAssigneeDocument}
          tableType={tableType}
          onLastNameSearch={handleLastNameSearch}
          onRequestSort={handleRequestSort}
          onSelectAllClick={handleSelectAllClick}
        />
        <TableBody>
          <>
            {tableContent}
            {emptyRows > 0 && (
              <TableRow>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </>
        </TableBody>
      </Table>
      <TablePagination
        square
        component={Paper}
        count={Object.keys(items).length}
        elevation={0}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
        sx={{
          position: 'sticky',
          bottom: 0,
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  )
}
